export default {"src":"/_next/static/media/icon-open.c16357e5.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};